<template>
  <div class="quicklinks-section">
    <h3 class="quicklinks-title">{{ title }}</h3>
     <p class="quicklinks-list">
      <span v-if="loading" class="quicklinks-loading">加载中…</span>
      <template v-else>
        <span v-for="(link, index) in displayLinks" :key="link.url" class="quicklinks-item">
          <span v-if="index > 0" class="quicklinks-sep">|</span>
          <a :href="link.url" target="_blank" rel="noopener noreferrer">{{ link.label }}</a>
        </span>
      </template>
    </p>
  </div>
</template>

<script>
// 其他快捷链接 - 公共组件，样式隔离（scoped）
// 链接数据从远程 API 获取（失败时回退内置默认），所有逻辑在本组件内实现
// API 返回结构：{ code:200, data:{ list:[ {name, link, status, sort_order, ...} ] } }
var API_BASE_URL = 'https://3qtools.cn'
var API_PATH = '/api/shortcut-links/list?pageIndex=1&pageSize=100'

var API_URL = API_BASE_URL + API_PATH

// 内置默认：API 请求失败或返回空时的兜底链接
var DEFAULT_LINKS = [
  { label: '3QTools 官方网站', url: 'https://3qtools.cn' },
  { label: 'APP下载示例站', url: 'https://home.3qtools.cn' },
  { label: '年会抽奖示例站', url: 'https://gift.3qtools.cn' }
]

export default {
  name: 'QuickLinks',
  props: {
    title: {
      type: String,
      default: '其他快捷链接'
    }
  },
  data: function () {
    return {
      // 关闭后整个组件渲染为空
      closed: false,
      // 是否正在请求 API
      loading: false,
      // 从 API 获取的链接（label/url），初始为空
      links: []
    }
  },
  computed: {
    // 加载中不显示链接（避免先显示默认再闪烁切换）；加载完优先用 API 数据，失败回退默认
    displayLinks: function () {
      if (this.loading) return []
      return this.links.length ? this.links : DEFAULT_LINKS
    }
  },
  mounted: function () {
    this.fetchLinks()
  },
  methods: {
    close: function () {
      this.closed = true
      // 通知父组件，便于父组件联动（如持久化关闭状态）
      this.$emit('close')
    },
    // 从 API 获取快捷链接列表
    // 用 XMLHttpRequest（IE11 原生支持，无需引入 fetch polyfill 或 axios）
    // 失败（网络/非 2xx/解析错误/空列表）时静默回退 DEFAULT_LINKS，不抛错
    fetchLinks: function () {
      var self = this
      self.loading = true
      var xhr = new XMLHttpRequest()
      xhr.open('GET', API_URL, true)
      xhr.timeout = 10000
      xhr.onreadystatechange = function () {
        if (xhr.readyState !== 4) return
        self.loading = false
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            var res = JSON.parse(xhr.responseText)
            var list = (res && res.data && res.data.list) || []
            // 过滤启用项 + 按 sort_order 升序 + 映射为 {label, url}
            var mapped = list
              .filter(function (item) { return item && item.status === 1 })
              .sort(function (a, b) { return (a.sort_order || 0) - (b.sort_order || 0) })
              .map(function (item) {
                return { label: item.name, url: item.link }
              })
            if (mapped.length) {
              self.links = mapped
            }
            // mapped 为空则保持 links=[]，displayLinks 会回退 DEFAULT_LINKS
          } catch (e) {
            // JSON 解析失败：静默回退默认
          }
        }
        // 非 2xx：静默回退默认
      }
      xhr.onerror = function () { self.loading = false }
      xhr.ontimeout = function () { self.loading = false }
      try {
        xhr.send()
      } catch (e) {
        self.loading = false
      }
    }
  }
}
</script>

<style scoped>
.quicklinks-section {
  padding: 10px 30px 15px;
  background-color: #fff;
  display: flex;
  gap: 20px;
  align-items: center;
  border-radius: 12px;
  margin-top: 20px;
}

.quicklinks-title {
  margin-bottom: 0;
  color: #3498db;
  font-size: 18px;
}

.quicklinks-list {
  line-height: 1.6;
  color: #bdc3c7;
  font-size: 14px;
  margin: 0;
}
.quicklinks-loading {
  color: #95a5a6;
  font-size: 14px;
}
.quicklinks-sep {
  margin: 0 8px;
  color: #bdc3c7;
}

.quicklinks-section a {
  color: #3498db;
  text-decoration: none;
}

.quicklinks-section a:hover {
  text-decoration: underline;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .quicklinks-section {
    padding: 10px 20px 20px;
    display: block;
  }

  .quicklinks-title {
    margin-bottom: 10px;
  }
}
</style>
